import type { ContractResponse } from '../types';

import { ENDPOINT } from '~/constants/endpoints';

import { type UUID } from '~/types/common';

import { type KyRequestOptions } from '@vestigas/data';

import { vestigasApi } from '~/services/kyClient';

import { zodContractResponseSchema } from '../validations';

/**
 * Duplicates an existing contract by its ID.
 * Creates a new contract with the same data as the original.
 *
 * @param contractId - The ID of the contract to duplicate.
 * @param options - Optional request options (e.g., abort signal).
 * @returns A promise that resolves with the duplicated contract.
 *
 * @see https://app.dev.vestigas.com/redoc#tag/Contracts/operation/duplicate_contract_contracts__contract_id__duplicate_post
 */
export const duplicateContract = async (
  contractId: UUID,
  options?: KyRequestOptions,
) =>
  vestigasApi
    .post(ENDPOINT.CONTRACT.DUPLICATE(contractId), {
      ...options,
      // Set after the options so no caller can switch the items back on: they
      // are always read from the paginated items endpoint.
      searchParams: { returnItems: false },
      validate: {
        ...options?.validate,
        response: zodContractResponseSchema,
      },
    })
    .json<ContractResponse>();
